import { FC, useEffect, useState } from "react";

export type OrganicMediaPlatform = "facebook" | "instagram" | "tiktok" | "snapchat";

export const isVideoMediaUrl = (url: string) => /\.(mp4|mov|m4v|webm)(?:[?#].*)?$/i.test(url);

const PLATFORM_FALLBACK_SRC: Record<OrganicMediaPlatform, string> = {
  facebook: "/Icons/fb-logo.webp",
  instagram: "/Icons/Insta-logo.webp",
  tiktok: "/Icons/TikTok_logo.svg",
  snapchat: "/Icons/snapchat_logo.webp",
};

interface PostMediaThumbProps {
  thumbnailUrl?: string;
  platform: OrganicMediaPlatform;
}

const PostMediaThumb: FC<PostMediaThumbProps> = ({ thumbnailUrl, platform }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [thumbnailUrl]);

  if (!thumbnailUrl || hasError) {
    return (
      <img
        src={PLATFORM_FALLBACK_SRC[platform]}
        alt=""
        loading="lazy"
        className={`organic-post-details__thumb-fallback organic-post-details__thumb-fallback--${platform}`}
      />
    );
  }

  if (isVideoMediaUrl(thumbnailUrl)) {
    return (
      <video src={thumbnailUrl} muted playsInline preload="metadata" onError={() => setHasError(true)} />
    );
  }

  return <img src={thumbnailUrl} alt="" loading="lazy" onError={() => setHasError(true)} />;
};

export default PostMediaThumb;
